<ul>
  <li *ngFor="let item of listOfItems$ | async ">
    <span style="cursor: pointer;" (click)="updateItem(item.id)">{{ item.name }} </span>

    <button inline="true" mat-mini-fab color="warn" (click)="deleteItem(item.id)" title="Eliminar item">
      <mat-icon>delete</mat-icon>
    </button>

  </li>
</ul>
